/* unplugin-vue-components disabled */import script from "./Jsjlr.vue?vue&type=script&lang=ts&setup=true"
export * from "./Jsjlr.vue?vue&type=script&lang=ts&setup=true"

import "./Jsjlr.vue?vue&type=style&index=0&id=06e4be08&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06e4be08"]])

export default __exports__